import Page from "../../layout/Page";
import {useTranslation} from "react-i18next";
import usePagination from "../../util/usePagination";
import dailyListService from "../../service/DailyListService";
import {DataTable} from "../../components/DataTable";
import Container from '@mui/material/Container';
import ListPageActions from "../../components/ListPageActions";
import {useNavigate} from "react-router-dom";
import {useMemo, useState} from "react";
import AddButton from "../../ui/AddButton";
import DeleteDialog from "../../components/DeleteDialog";
import {parseAndFormatDate} from "../../util/DateUtil";
import ApplicationOptions from "../../components/ApplicationOptions";

const DailyListListPage = ({title}) => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [selected, setSelected] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const dailyLists = usePagination({
        service: dailyListService,
        defaultSearchData: {
            date: undefined
        }
    });

    const columns = useMemo(() => [
        {
            name: "date",
            label: t('label.date'),
            execute: (date) => parseAndFormatDate(date),
            type: Date,
            searchable: true
        },
        {
            name: "application",
            label: t('label.application'),
            execute: (application) => application?.name,
            searchable: true,
            searchType: "select",
            selectOptions: <ApplicationOptions/>
        },
        {
            name: "title",
            label: t('label.title'),
            searchable: true,
        },
    ], [dailyLists]);


    const ActionButtons = () => (
        <ListPageActions>
            <AddButton onClick={() => {
                navigate(`/daily-lists/create`)
            }}/>
        </ListPageActions>
    )

    return (
        <Page title={title}>
            <Container maxWidth={"lg"}>
                <ActionButtons/>
                <DataTable
                    title={t('title.dailyListList')}
                    columns={columns} {...dailyLists}
                    onEdit={(item) => {
                        navigate(`/daily-lists/edit/${item._id}`);
                    }}
                    onDelete={(item) => {
                        setSelected(item);
                        setOpenDeleteDialog(true);
                    }}
                />
                <ActionButtons/>
            </Container>

            <DeleteDialog
                item={selected}
                itemService={dailyListService}
                message={selected?.title}
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                    setSelected(null)
                }}
                onDoneCallback={dailyLists.search}
            />
        </Page>
    );
}

export default DailyListListPage;
